import React, { useEffect, useState, useRef } from 'react';
import { getAllSubmissions, getNextReportType } from '../../services/submissionService';
import CommentSection from "./CommentSection"; 
import axiosInstance from '../../api/axios';
import { Button, TextField, IconButton, Alert } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import { Link } from "react-router-dom";
import "./datatable.scss"
import { DataGrid } from '@mui/x-data-grid';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import VivaChatWidget from "./VivaChatWidget";
import { isSlotActive } from "../../hooks/ChatUtils";

export const SubmissionList = () => {
  const [file, setFile] = useState(null);
  const [presentationFile, setPresentationFile] = useState(null);
  const [presentationVideo, setPresentationVideo] = useState(null);
  const [turnitin, setTurnitin] = useState(null);
  const [rebuttalReportFile, setRebuttalReportFile] = useState(null);
  const [codeDemoFile, setCodeDemoFile] = useState(null);
  const [termType, setTermType] = useState('');
  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);
  const fileInputRef3 = useRef(null);
  const fileInputRef4 = useRef(null);
  const fileInputRef5 = useRef(null);
  const fileInputRef6 = useRef(null);
  
  const [submissions, setSubmissions] = useState([]);
  const [isSubmiited, setIsSubmiited] = useState(false);
 //   const [isGraded, setIsGraded] = useState(false);
 //    const [isFeedback, setIsFeedback] = useState(false);
  //   const [isGradeI, setIsGradeI] = useState(false);


  const [errors, setErrors] = useState({});
  const [reportType, setReportType] = useState(null); 
  const [submissionType, setSubmissionType] = useState(null);
  const [submissionDate, setSubmissionDate] = useState(null);
  const [announcementId, setAnnouncementId] = useState(null);
  // Deadline for the ProjectParticular form specifically. Kept separate from
  // submissionDate because ProjectParticular and ProjectProposal are the only
  // two report types that can be open for a student at the same time, and each
  // has its own dedicated form/route.
  const [particularSubmissionDate, setParticularSubmissionDate] = useState(null);
  const [reportLink, setReportLink] = useState(null);
  const [month, setMonth] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [studentId, setStudentId] = useState(localStorage.getItem('studentId'));
  const [thesisExists, setThesisExists] = useState(false);
  const [degreeName, setDegreeName] = useState(null);

  const [similarityStatus, setSimilarityStatus] = useState(null);
  const [similarityResult, setSimilarityResult] = useState(null);

  const [reportStatus, setReportStatus] = useState(null);  
  const [reportResult, setReportResult] = useState(null);

  const [videoStatus, setVideoStatus] = useState(null);
  const [videoResult, setVideoResult] = useState(null);
  const [videoMessage, setVideoMessage] = useState("");

  const [isAnalyzing, setIsAnalyzing] = useState(false);

  const [thesisStatusId, setThesisStatusId] = useState(null);

  const latest = submissions[0];

  const [uploadedFiles, setUploadedFiles] = useState({});

  const reportUploaded = uploadedFiles?.Report;
  const presentationUploaded = uploadedFiles?.Presentation_File;
  const presentationVideoUploaded = uploadedFiles?.Presentation_Video;
  const turnitinUploaded = uploadedFiles?.Turnitin;
  const rebuttalUploaded = uploadedFiles?.Rebuttal_Report_File;
  const codeDemoUploaded = uploadedFiles?.Code_Demo_File;

  const deadlinePassed = new Date() > new Date(submissionDate + "T23:59:59");

  const [uploadingFileType, setUploadingFileType] = useState(null);

  const [fileLinks, setFileLinks] = useState({});

  const [vivaIds, setVivaIds] = useState([]);

  useEffect(() => {
      if (studentId) {
        axiosInstance
          .get(`/project-particular/${studentId}`)
          .then((res) => {
            const thesisData = res.data?.data?.thesis;
            if (thesisData && thesisData.id) {
              setThesisExists(true);
            } else {
              setThesisExists(false);
            }
          })
          .catch((err) => {
            console.log("No project particulars found yet");
            setThesisExists(false);
          });
      }
    }, [studentId]);

  useEffect(() => {
    if (
      !studentId ||
      !announcementId ||
      !termType ||
      !reportType
    ) {
      return;
    }

    initSubmission();

  }, [studentId, announcementId, termType, reportType]);

  useEffect(() => {
    if (!thesisStatusId) return;

    axiosInstance
      .get(`/files/status/${thesisStatusId}`)
      .then(res => setUploadedFiles(res.data.data))
      .catch(console.error);

  }, [thesisStatusId]);

  useEffect(() => {
    if (!reportResult) return;

    if (reportResult.status === "error" && reportResult.margin_issues?.length) {
      const formattedMessage = reportResult.margin_issues
        .map(([page, msg]) => `Page ${page}: ${msg}`)
        .join("\n");

      toast.error(formattedMessage);
    } else if (reportResult.message) {
      toast.success(reportResult.message);
    }
  }, [reportResult]);

  useEffect(() => {
    if (videoMessage) {
      if(videoStatus==="error"){
        toast.error(videoMessage);
      }
      else{
        toast.success(videoMessage);
      }
    }
  }, [videoMessage]);

  useEffect(() => {
    if (!similarityResult?.message) return;

    if (similarityStatus === "error") {
      toast.error(similarityResult.message);
    } else {
      toast.success(similarityResult.message);
    }
  }, [similarityResult, similarityStatus]);

  const fetchFileLink = async (fileType) => {
    try {
      const res = await axiosInstance.get("/files/presign-download", {
        params: {
          thesisStatusId,
          fileType
        }
      });

      setFileLinks(prev => ({
        ...prev,
        [fileType]: {
          url: res.data.data.downloadUrl,
          originalFilename: res.data.data.originalFilename
        }
      }));
    } catch (e) {
      console.error(`Failed to fetch ${fileType}`, e);
    }
  };

  useEffect(() => {
    if (!thesisStatusId) return;

    if (reportUploaded) fetchFileLink("Report");
    if (presentationUploaded) fetchFileLink("Presentation_File");
    if (presentationVideoUploaded) fetchFileLink("Presentation_Video");
    if (turnitinUploaded) fetchFileLink("Turnitin");
    if (rebuttalUploaded) fetchFileLink("Rebuttal_Report_File");
    if (codeDemoUploaded) fetchFileLink("Code_Demo_File");

  }, [
    thesisStatusId,
    reportUploaded,
    presentationUploaded,
    presentationVideoUploaded,
    turnitinUploaded,
    rebuttalUploaded,
    codeDemoUploaded
  ]);

  const fetchSubmissions = async () => {
    try {
      const data = await getAllSubmissions(studentId);
     // console.log(data);
      setSubmissions(data.data);
      const ids = data.data
        .map(d => d.vivaId)
        .filter(id => id != null);

      setVivaIds(ids);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleTermType = (event) => {
    event.preventDefault();
    setTermType(event.target.value);
    if (!event.target.value) {
      setErrors({ termType: "Please select a submission type." });
      return;
    }
  
    //console.log("Submitting Term Type:", termType);
    //setTermType(termType)
    // Submit form logic here
  };
  
// added comment to activate push
  const handleFileChange = async(event) => {
    //setFile(null);
    const selectedFile = event.target.files[0];
    const maxFileSize = 10 * 1024 * 1024; // 10 MB
    const allowedTypes = [
      //'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      //'application/vnd.ms-excel', // .xls
      //'text/csv' // .csv
    ];

    // if (selectedFile && selectedFile.size > maxFileSize) {
    //   toast.error('File size exceeds 10 MB limit');
    //   event.target.value = '';
    //   return;
    // }
    // else if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
    //   toast.error('Only pdf files are allowed');
    //   event.target.value = '';
    //   return;
    // }
    // else {
    setFile(selectedFile);
    //}
    setErrors((prev) => ({ ...prev, reportLink: '' }));
    const formData = new FormData();
    formData.append("file", selectedFile);

    if (!selectedFile) {
      setFile(null);
      setReportStatus(null);
      setReportResult(null);
      return;
    }

    try {
      setIsAnalyzing(true);
      const response = await axiosInstance.post("/predict", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      setReportResult(response.data); // { status, message, margin_issues }
      setReportStatus(response.data.status);
    } catch (err) {
      console.error("Error analyzing report:", err);
      setReportResult({ status: "error", message: "Failed to analyze report" });
      setReportStatus("error");
    }
    finally {
        setIsAnalyzing(false); 
      }
    };

  const handlePresentationFileChange = (event) => {
    setPresentationFile(null);
    const selectedFile = event.target.files[0];
    // const maxFileSize = 10 * 1024 * 1024; // 10 MB
    // const allowedTypes = [
    //   //'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    //   //'application/vnd.ms-excel', // .xls
    //   //'text/csv' // .csv
    // ];

    // if (selectedFile && selectedFile.size > maxFileSize) {
    //   toast.error('File size exceeds 10 MB limit');
    //   event.target.value = '';
    //   return;
    // }
    // else if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
    //   toast.error('Only pdf files are allowed');
    //   event.target.value = '';
    //   return;
    // }
    // else {
    setPresentationFile(selectedFile);
    setErrors((prev) => ({ ...prev, presentationLink: '' }));
    //}
  };
  const handleRebuttalReportFileChange = (event) => {
    setRebuttalReportFile(null);
    const selectedFile = event.target.files[0];
    // const maxFileSize = 10 * 1024 * 1024; // 10 MB
    // const allowedTypes = [
    //   //'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    //   //'application/vnd.ms-excel', // .xls
    //   //'text/csv' // .csv
    // ];

    // if (selectedFile && selectedFile.size > maxFileSize) {
    //   toast.error('File size exceeds 10 MB limit');
    //   event.target.value = '';
    //   return;
    // }
    // else if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
    //   toast.error('Only pdf files are allowed');
    //   event.target.value = '';
    //   return;
    // }
    // else {
    setRebuttalReportFile(selectedFile);
    setErrors((prev) => ({ ...prev, setRebuttalReportLink: '' }));
    //}
  };
  const handlePresentationVideoChange = async(event) => {
    //setPresentationVideo(null);
    const selectedFile = event.target.files[0];
    // const maxFileSize = 10 * 1024 * 1024; // 10 MB
    // const allowedTypes = [
    //   //'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    //   //'application/vnd.ms-excel', // .xls
    //   //'text/csv' // .csv
    // ];

    // if (selectedFile && selectedFile.size > maxFileSize) {
    //   toast.error('File size exceeds 10 MB limit');
    //   event.target.value = '';
    //   return;
    // }
    // else if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
    //   toast.error('Only pdf files are allowed');
    //   event.target.value = '';
    //   return;
    // }
    // else {
      setPresentationVideo(selectedFile);
    setErrors((prev) => ({ ...prev, presentationVideoLink: '' }));
    //}
    const formData = new FormData();
    formData.append("file", selectedFile);

    if (!selectedFile) {
      setPresentationVideo(null);
      setVideoStatus(null);
      setVideoMessage(""); 
      return;
    }

    try {
      setIsAnalyzing(true);
      const response = await axiosInstance.post("/check-video-duration", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      const result = response.data;
      setVideoResult(result);

      // Apply phase rules on frontend
      let limitSeconds = 0;
      if (reportType === "Phase1" || reportType === "Phase2") {
        limitSeconds = 8 * 60;
      } else if (reportType === "Phase3") {
        limitSeconds = 12 * 60 ;
      }else if (reportType === "ProjectProposal") {
        limitSeconds = 5 * 60;
      }

      const limitSizeMB = 50;

      if (result.duration_seconds > limitSeconds + 10|| result.size_mb > limitSizeMB + 5) { // allow some buffer for size as it can vary based on encoding
        const limitMinutes = Math.floor(limitSeconds / 60);
        const limitSecs = limitSeconds % 60;

        setVideoMessage(
          `❌ Video too long or too big:
          Duration: ${result.duration_formatted} (limit ${limitMinutes}:${limitSecs.toString().padStart(2,'0')})
          Size: ${result.size_mb} MB (limit ${limitSizeMB} MB).
          Please upload another file within the allowed limits.`
        );
        setVideoStatus("error");
        setPresentationVideo(null);

      } else {
        setVideoMessage(`✅ Video accepted (${result.duration_formatted}), proceed with upload`);
        setVideoStatus("ok");
      }

    } catch (error) {
      console.error("Error uploading video", error);
      setVideoMessage("❌ Error checking video duration");
      setVideoStatus("error");
      setPresentationVideo(null);
    }
    finally {
              setIsAnalyzing(false); 
            }
    };
  const handleCodeDemoFileChange = async(event) => {
    setCodeDemoFile(null);
    const selectedFile = event.target.files[0];
    // const maxFileSize = 10 * 1024 * 1024; // 10 MB
    // const allowedTypes = [
    //   //'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    //   //'application/vnd.ms-excel', // .xls
    //   //'text/csv' // .csv
    // ];

    // if (selectedFile && selectedFile.size > maxFileSize) {
    //   toast.error('File size exceeds 10 MB limit');
    //   event.target.value = '';
    //   return;
    // }
    // else if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
    //   toast.error('Only pdf files are allowed');
    //   event.target.value = '';
    //   return;
    // }
    // else {
      setCodeDemoFile(selectedFile);
    setErrors((prev) => ({ ...prev, codeDemoLink: '' }));
    //}
    const formData = new FormData();
    formData.append("file", selectedFile);

    if (!selectedFile) {
      setCodeDemoFile(null);
      setVideoStatus(null);
      setVideoMessage(""); 
      return;
    }

    try {
      setIsAnalyzing(true);
      const response = await axiosInstance.post("/check-video-duration", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      const result = response.data;
      setVideoResult(result);

      const limitSeconds = 15 * 60; // 15 minutes
      const limitSizeMB = 100; // 100 MB

      if (result.duration_seconds > limitSeconds + 10 || result.size_mb > limitSizeMB + 5) { // allow some buffer as it can vary based on encoding
        const limitMinutes = Math.floor(limitSeconds / 60);
        const limitSecs = limitSeconds % 60;

        setVideoMessage(
          `❌ Video too long or too big:
          Duration: ${result.duration_formatted} (limit ${limitMinutes}:${limitSecs.toString().padStart(2,'0')})
          Size: ${result.size_mb} MB (limit ${limitSizeMB} MB).
          Please upload another file within the allowed limits.`
        );
        setVideoStatus("error");
        setCodeDemoFile(null);

      } else {
        setVideoMessage(`✅ Video accepted (${result.duration_formatted}), proceed with upload`);
        setVideoStatus("ok");
      }

    } catch (error) {
      console.error("Error uploading video", error);
      setVideoMessage("❌ Error checking video duration/size");
      setVideoStatus("error");
      setCodeDemoFile(null)
    }
    finally {
              setIsAnalyzing(false);
            }
    };
  const handleTurnitinChange = async(event) => {
    //setTurnitin(null);
    const selectedFile = event.target.files[0];
    // const maxFileSize = 10 * 1024 * 1024; // 10 MB
    // const allowedTypes = [
    //   //'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    //   //'application/vnd.ms-excel', // .xls
    //   //'text/csv' // .csv
    // ];

    // if (selectedFile && selectedFile.size > maxFileSize) {
    //   toast.error('File size exceeds 10 MB limit');
    //   event.target.value = '';
    //   return;
    // }
    // else if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
    //   toast.error('Only pdf files are allowed');
    //   event.target.value = '';
    //   return;
    // }
    // else {
    setTurnitin(selectedFile);
    setErrors((prev) => ({ ...prev, turnitin: '' }));
    const formData = new FormData();
    formData.append("file", selectedFile);

    if (!selectedFile) {
      setTurnitin(null);
      setSimilarityStatus(null);
      setSimilarityResult(null);
      return;
    }

    try {
      setIsAnalyzing(true);
      const response = await axiosInstance.post("/check-similarity", formData, {
        
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      setSimilarityResult(response.data.similarity_index); // { similarity_index, total_pages, message }
      setSimilarityStatus(response.data.similarity_index.status);
    } catch (err) {
      console.error("Error checking similarity:", err);
      setSimilarityResult({ message: "Error checking similarity index" });
      setSimilarityStatus("error");
     // console.log(similarityStatus);

    }
    finally {
              setIsAnalyzing(false);  
            }
      //}
    };

  const fetchNextReportType = async () => {
  try {
    const data = await getNextReportType(studentId);

    const info = (data && data.data) ? data.data : {};


    const primaryType = info.report_type || null;
    const secondaryType = info.secondary_report_type || null;
    const tertiaryType = info.tertiary_report_type || null;

    // Keep the original working logic
    const useSecondaryForGenericForm =
      primaryType === "ProjectParticular" && !!secondaryType;

    setReportType(
      useSecondaryForGenericForm ? secondaryType : primaryType
    );

    setSubmissionType(info.term_type || null);
    setMonth(info.month || null);

    setSubmissionDate(
      useSecondaryForGenericForm
        ? (info.secondary_submission_date || null)
        : (info.submission_date || null)
    );

    setAnnouncementId(
      useSecondaryForGenericForm
        ? (info.secondary_announcement_id || null)
        : (info.announcement_id || null)
    );

    setIsSubmiited(info.is_submitted || false);
    setDegreeName(info.degree_name || null);

    setParticularSubmissionDate(
      primaryType === "ProjectParticular"
        ? (info.submission_date || null)
        : secondaryType === "ProjectParticular"
          ? (info.secondary_submission_date || null)
          : tertiaryType === "ProjectParticular"
            ? (info.tertiary_submission_date || null)
            : null
    );

  } catch (err) {
    console.log(err);
    setError(err);
  } finally {
    setLoading(false);
  }
};
  useEffect(() => {

    fetchSubmissions();
    fetchNextReportType();


  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!reportType || !reportType.trim()) {
      newErrors.reportType = 'reportType is required';
    }
    if(!termType || !termType.trim()) {
      newErrors.termType = 'Submission Type is required';
    }
    if (!file) {
      newErrors.reportLink = 'Report File is required';
    }
    if ((termType == 'EndTerm' || termType == 'EndTerm_Resubmission') && (!presentationFile || !presentationFile)) {
      newErrors.presentationFile = 'Presentation File is required';
    }
    if ((termType == 'EndTerm' || termType == 'EndTerm_Resubmission') && (!presentationVideo || !presentationVideo)) {
      newErrors.presentationVideo = 'Presentation Video is required';
    }

    if (reportType !== 'ProjectProposal' && (termType == 'EndTerm' || termType == 'EndTerm_Resubmission') && (!rebuttalReportFile || !rebuttalReportFile)) {
      newErrors.rebuttalReportFile= 'Rebuttal Report is required';
    }
    

    if ((termType == 'EndTerm' || termType == 'EndTerm_Resubmission') && reportType == "Phase3" && (!codeDemoFile || !codeDemoFile)) {
      newErrors.codeDemoFile = 'Code Demo File is required';
    }
    if ((termType == 'EndTerm' || termType == 'EndTerm_Resubmission') && (reportType !== 'Monthly' && !turnitin)) {
      newErrors.turnitin = 'Turnitin is required';
    }

    setErrors(newErrors);
    console.log(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    var response = '';
    try {
      setLoading(true);
      var submission = {
        studentId: studentId,
        reportLink: reportLink,
        reportType: reportType,
        isSubmitted: true,
        reportMonth: month,
        dateSubmitted: new Date(),
        announcementId: announcementId,
        termType : termType

      }
     // console.log(submission)
      const formData = new FormData();

      // Append submission data
      formData.append('submissionData', JSON.stringify(submission));

      // Append files
      formData.append('reportFile', file);
      if(termType === 'EndTerm' || termType === 'EndTerm_Resubmission') {
      formData.append('presentationFile', presentationFile);
      formData.append('presentationVideo', presentationVideo);
      formData.append('rebuttalReportFile', rebuttalReportFile);
      formData.append('codeDemoFile',codeDemoFile);
      formData.append('turnitin', turnitin);
      } 
      
      response = await axiosInstance.post('/addSubmission', formData, {
       headers: {
          'Content-Type': 'multipart/form-data'
        },
     //   maxBodyLength: Infinity,
  //maxContentLength: Infinity,
 // timeout: 0, // prevent timeout for large uploads
        showToastOnResponse: true
      });


      
      fetchSubmissions();
      setReportType('');
      setTermType('');
      setReportLink('');
      fetchNextReportType();
      setFile(null);
      setPresentationFile(null);
      setRebuttalReportFile(null);
      setPresentationVideo(null);
      setCodeDemoFile(null);
      setTurnitin(null);
      if (fileInputRef1 && fileInputRef1.current) {
        fileInputRef1.current.value = '';
      }
      if (fileInputRef2 && fileInputRef2.current) {
        fileInputRef2.current.value = '';
      }
      if (fileInputRef3 && fileInputRef3.current) {
        fileInputRef3.current.value = '';
      }
      if (fileInputRef4 && fileInputRef4.current) {
        fileInputRef4.current.value = '';
      }
      if (fileInputRef5 && fileInputRef5.current) {
        fileInputRef5.current.value = '';
      }
      if (fileInputRef6 && fileInputRef6.current) {
        fileInputRef6.current.value = '';
      }

    } catch (error) {
      console.log('Error saving course. Please try again later.');
      console.log(error);
      setReportType('');
      setReportLink('');
      fetchNextReportType();
      setFile(null);
      setPresentationFile(null);
      setRebuttalReportFile(null);
      setPresentationVideo(null);
      setCodeDemoFile(null);
      setTurnitin(null);
      if (fileInputRef1 && fileInputRef1.current) {
        fileInputRef1.current.value = '';
      }
      if (fileInputRef2 && fileInputRef2.current) {
        fileInputRef2.current.value = '';
      }
      if (fileInputRef3 && fileInputRef3.current) {
        fileInputRef3.current.value = '';
      }
      if (fileInputRef4 && fileInputRef4.current) {
        fileInputRef4.current.value = '';
      }
      if (fileInputRef5 && fileInputRef5.current) {
        fileInputRef5.current.value = '';
      }
      if (fileInputRef6 && fileInputRef6.current) {
        fileInputRef6.current.value = '';
      }
      if (error && (!error.response || !error.response.data))
        toast.error('Uploaded file changed. Please select file again');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setReportLink(e.target.value);
  };
  const handleTypeChange = (e) => {
    setReportType(e.target.value);
  };
  const handleLinkClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  const handleEditClick = (id) => {
    console.log(`Edit row with id ${id}`);
    // Implement edit functionality here
  };
  const hasSubmittedEndTerm = (reportType) => {
  return submissions.some((sub) => sub.report_type === reportType && sub.term_type === termType) ;
};

const [slots, setSlots] = useState([]);

const enrichedSlots = slots.map(slot => ({
  ...slot,
  students: submissions.filter(r => slot.vivaIds?.includes(r.vivaId))
}));

useEffect(() => {
  fetchSlots();
}, [vivaIds]);
    
const fetchSlots = async () => {
  try {
    if (!vivaIds.length) return;

    const params = new URLSearchParams();
    vivaIds.forEach(id => params.append("vivaIds", id));

    const res = await axiosInstance.get(`/viva/slots?${params.toString()}`);

    setSlots(res.data?.data || []);
  } catch (err) {
    console.error(err);
  }
};

  const columns = React.useMemo(
    () => [
      {
        field: 'combined_report',
        headerName: 'Report Type',
        width: 150,
        renderCell: (params) => {
          const reportType = params.row?.report_type || '';
          const reportMonth = params.row?.report_month || '';
          if (reportType == 'ProjectProposal')
            return 'Project Proposal'
          return `${reportType}  ${reportMonth}`;
        },
      },
      {
        field: 'report',
        headerName: 'Submission Type',
        width: 200,
        renderCell: (params) => {
          const submissionType = params.row?.term_type || '';
          const submissionMonth = params.row?.report_month || '';
          if (submissionType == 'ProjectProposal')
            return 'Project Proposal'
          return `${submissionType}  ${submissionMonth}`;
        },
      },
      /*
      {
        field: 'folder_link', headerName: 'Folder Link', width: 150, renderCell: (params) => (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Link
              href={params.value}
              onClick={(event) => handleLinkClick(params.value, event)}
              style={{
                color: 'blue',
                textDecoration: 'underline',
                marginRight: '10px',
                cursor: 'pointer',
              }}
            >
              {params.value}
            </Link>
          </div>
        ),
      }, */
      { field: 'date_submitted', headerName: 'Date Submitted', width: 150 },
    //  { field: 'submission_deadline', headerName: 'Submission Deadline', width: 180 },
    //  { field: 'submission_deadline_pptvideo', headerName: 'Presentation Deadline', width: 180 },
      {
        field: 'status',
        headerName: 'Status',
        width: 150,
        renderCell: (params) => {
          const submission_deadline = params.row?.submission_deadline || '';
          const date_submitted = params.row?.date_submitted || '';
          
          if (date_submitted && date_submitted <= submission_deadline) {
            return 'Submitted';
          }
          if (date_submitted && date_submitted > submission_deadline) {
            return 'Delayed';
          }
     //     if (date_submitted == '' && (new Date()) > (new Date(submission_deadline))) {
     //       return 'Missed';
     //     }
        //  return 'Pending';
        
        },
      },
      // { field: 'date', headerName: 'Viva Date', width: 150 },
      // { field: 'startTime', headerName: 'Viva Start Time', width: 150 },
      // { field: 'endTime', headerName: 'Viva End Time', width: 150 },
      {
        field: "vivaSchedule",
        headerName: "Viva Schedule",
        width: 260,
        renderCell: (params) => {
          const { date, startTime, endTime } = params.row || {};

          if (!date || !startTime || !endTime) {
            return <span style={{ color: "#999" }}>Not Scheduled</span>;
          }

          return (
            <div style={{ lineHeight: "18px" }}>
              <div style={{ fontWeight: 600 }}>{date}</div>
              <div style={{ fontSize: 12, color: "#555" }}>
                {startTime} – {endTime}
              </div>
            </div>
          );
        },
    },
    ],
    []
  );

  if (error) return <p>Error: {error.message}</p>;

 const actionColumn = [
  {
    field: "action", headerName: "Action", width: 200,
    renderCell: (params) => {
      const {
        id,
        date_submitted,
        submission_deadline,
        submission_deadline_pptvideo,
        submission_id,
        term_type,
        has_feedback,
        is_active,
	is_current,
        report_type,
        report_month
      } = params.row;
      
      
      const isMidTermOnly = term_type === "MidTerm" && !hasSubmittedEndTerm(report_type);

      return (
        <div className="cellAction">
          {date_submitted && (
            <div className="viewButton">
              <Link to={{ pathname: `/student/view-submission/${submission_id}` }} style={{ textDecoration: "none" }}>
                View
              </Link>
            </div>
          )}
          

          {/* {date_submitted && (
            (term_type === "MidTerm" && new Date() < new Date(submission_deadline+'T23:59:59')) ||
            (term_type === "RevisedReport" && new Date() < new Date(submission_deadline+'T23:59:59')) ||
            (term_type === "EndTerm" && new Date() < new Date(submission_deadline_pptvideo+'T23:59:59')) ||
            (term_type === "EndTerm_Resubmission" && new Date() < new Date(submission_deadline_pptvideo+'T23:59:59')
          )) && !has_feedback && is_current && (
            <div className="editButton">
              <Link to={`/student/edit-submission/${submission_id}`} state={{
                submission_deadline: submission_deadline,
                date_submitted: date_submitted,
                submission_deadline_pptvideo: submission_deadline_pptvideo
              }} style={{ textDecoration: "none" }}>
                Edit
              </Link>
            </div>
          )} */}

	      {/* { 
          isMidTermOnly && (
              <div className="editButton">
                <Link
                  to={`/student/upload-submission/${id}/${report_type}/${report_month}`}
                  state={{ isEndTermUpload: true }}
                  style={{ textDecoration: "none" }}
                >
                  Upload End Term
                </Link>
              </div>
          )}


	       {!date_submitted && (new Date()) > (new Date(submission_deadline)) && (
            <div className="editButton">
              <Link to={{ pathname: `/student/upload-submission/${id}/${report_type}/${report_month}` }} style={{ textDecoration: "none" }}>
                Upload
              </Link>
            </div>
          )} */}

          
        </div>
      );
    }
  },
  /*  Rebuttal report upload column disabled for now
  {
    field : "Rebuttal Report" , headerName : "Rebuttal Report" , width : 150,
    renderCell: (params) => {
      const { date_submitted,submission_id, rebuttal_report_link } = params.row;
      // const report_type = params.row?.report_type || '';
      // const report_month = params.row?.report_month || null;
      return (
        <div className="cellAction">
          {date_submitted && <div className="editButton">
            <Link to={{ pathname: `/student/edit-submission/${submission_id}` }} 
            state={{
              isRebuttal: true // This will signal that it's a rebuttal upload
            }}
            style={{ textDecoration: "none" }}>{rebuttal_report_link? "Edit" : "Upload"}</Link></div>}
          </div>
          )
    }
  } */
]

const finalColumns = columns.concat(actionColumn).concat([
  {
    field: "comments",
    headerName: "Comments",
    width: 300,
    renderCell: (params) => {
      const submissionId = params.row.submission_id;
      const senderId = localStorage.getItem("userId");
      const has_feedback = params.row.has_feedback;

   //   if (!submissionId) {
   //     return <span style={{ color: "gray" }}>No Submission</span>;
   //   }

   //   if (!has_feedback) {
   //     return <span style={{ color: "gray" }}>Evaluation is pending</span>;
   //   }
     if (submissionId && has_feedback) {
      return <CommentSection submissionId={submissionId} senderId={senderId} />;
    }
    else {
      return <span style={{ color: "gray" }}>No Comments</span>;
  }
  }
}
]);
  

  const now = new Date();

  const particularDeadline = particularSubmissionDate ? new Date(particularSubmissionDate + 'T23:59:59') : null;

  const isDisabled =
    !particularDeadline
      ? true
      : now >= particularDeadline;

  const initSubmission = async () => {
    try {
      const res = await axiosInstance.post(
        "/submission/init",
        {
          studentId,
          announcementId,
          termType,
          reportType
        }
      );

    const tsId = res.data.data.thesisStatusId;

    setThesisStatusId(tsId);

  } catch (err) {
    console.error("initSubmission failed", err);
  }
};

const uploadSingleFile = async ({
  fileCategory,
  fileType,
  thesisStatusId,
  studentId,
  announcementId,
  termType,
  fileRef,
  clearState
}) => {
  if (!fileCategory){
    toast.warning("Please select a file to proceed");
    return;
  }

  if (!thesisStatusId) {
    toast.error("Please select submission type");
    return;
  }

  try {
    setUploadingFileType(fileType); 

    const presignRes = await axiosInstance.post(
      "/files/presign-upload",
      {
        thesisStatusId,
        studentId,
        announcementId,
        termType,
        fileType,
        reportType,
        filename: fileCategory.name
      }
    );

    const { uploadUrl, objectKey } = presignRes.data;

    const uploadRes = await fetch(uploadUrl, {
      method: "PUT",
      body: fileCategory,
      headers: {
        "Content-Type": fileCategory.type || "application/octet-stream"
      }
    });

    if (!uploadRes.ok) {
      throw new Error("Object storage upload failed");
    }

    await axiosInstance.post("/files/metadata", {
      thesisStatusId,
      studentId,
      announcementId,
      fileType,
      objectKey,
      originalFilename: fileCategory.name
    });

    toast.success(`${fileType} uploaded successfully`);

    await fetchFileLink(fileType);

    if (fileRef?.current) {
      fileRef.current.value = "";
    }

    if(clearState){
      clearState(null);
    }

    await refreshUploadedFiles(thesisStatusId);

  } catch (err) {
    console.error(err);
    toast.error(err.message || "Upload failed");
  } finally {
    setUploadingFileType(null); 
  }
};

const refreshUploadedFiles = async (tsId) => {
  if (!tsId) return;

  try {
    const res = await axiosInstance.get(`/files/status/${tsId}`);
    setUploadedFiles(res.data.data);
  } catch (err) {
    console.error("Failed to refresh file status", err);
  }
};

const myVivaIds = submissions
  .map(s => s.vivaId)
  .filter(Boolean);

  return (
    <div>
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
{degreeName !== 'PGD' && <div className="top">
       {/* Add this button or link */}
      {/* <Link to="project-particular-form">
        <button type="button">Fill Project Particular Form</button>
      </Link>
    </div> */}
    <>
      {thesisExists ? (
        <Link to={`update-project-particular/${studentId}`}
          state={{ reportType: "ProjectParticular", submissionDate: particularSubmissionDate }}
          >
          <button type="button">View Project Particular Form</button>
        </Link>
      ) : (
        <Link to="project-particular-form">
          <button type="button" disabled = {isDisabled}>Fill Project Particular Form</button>
        </Link>
      )}
    </>
    </div>}
     {degreeName !== 'PGD' && <div className='top'>
      {new Date() < new Date('2025-10-01T00:05:00') ? (
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSdvDoSrgZFqJ2O8-WV29sbOJ1lfv_yHkxCNAqQF__2etFTpzg/viewform?usp=header"
          target="_blank"
          rel="noopener noreferrer"
        >
          Project Proposal Form
        </a>
      ) : (
        <span style={{ color: "gray", cursor: "not-allowed" }}>
          Project Proposal Form (Expired)
        </span>
      )}
    </div>}

      {(() => {
        const today = new Date();
        const todayLocalISO = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

        const upcomingVivaSubmission = submissions.find(
          (s) => s.date && s.startTime && s.endTime && s.date >= todayLocalISO
        );

        return upcomingVivaSubmission && (
          <Alert severity="info" sx={{ mb: 2 }}>
            <strong>Viva Scheduled for : </strong>{upcomingVivaSubmission.report_type} - {upcomingVivaSubmission.term_type}<br />
            Date: {upcomingVivaSubmission.date}<br />
            Start Time: {upcomingVivaSubmission.startTime}<br />
            End Time: {upcomingVivaSubmission.endTime}
          </Alert>
        );
      })()}

      <div className="datatable" >
        {reportType != "ProjectParticular" && (new Date()) <= new Date(submissionDate + 'T18:30:59') && <div className="datatableTitle"  >

          <form onSubmit={handleSubmit} style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '20px', backgroundColor: 'lightgrey', padding: '5px', borderRadius: '5px' }}>

            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', width: '100%' }}>
              <div className="import" style={{ position: 'relative' }}>
                <label style={{ color: 'red', fontWeight: 'bold' }}>Submission Deadline {' '}</label>

                <input type="text"
                  name="submissionDate"
                  value={submissionDate + ', 5:30pm'}
                  readOnly={true}
                  className={'star-input'} />

                {errors.submissionDate && <div className="error-text">{errors.submissionDate}</div>}
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', width: '100%' }}>
              <div className="import">
                <label>Report Type {' '}</label>

                <input type="text"
                  name="reportType"
                  value={reportType}
                  readOnly={true}
                  className={errors.reportType ? 'error' : ''} />
                {errors.reportType && <div className="error-text">{errors.reportType}</div>}
              </div>
              <div className="import">
                <label>Term Type {' '}</label>

                <select
                name="termType"
                value={termType}
                onChange={handleTermType}
                className={errors.termType ? 'error' : ''}
                >
                <option value="">Select Submission Type</option>
                <option value="RevisedReport" disabled={"RevisedReport" !== submissionType} >Revised Report (only report)</option>
                <option value="EndTerm" disabled={"EndTerm" !== submissionType}>All files</option>
                <option value="EndTerm_Resubmission" disabled={"EndTerm_Resubmission" !== submissionType}>All files (Resubmission)</option>
                <option value="MidTerm" disabled={"MidTerm" !==submissionType}>Only Progress Report  </option>
                </select>
                
              {errors.termType && <div className="error-text">{errors.termType}</div>}
             </div>
              {reportType === 'Monthly' && <div className="import">
                <label>Report Month {' '}</label>

                <input type="text"
                  name="month"
                  value={month}
                  readOnly={true}
                  className={errors.month ? 'error' : ''} />
                {errors.month && <div className="error-text">{errors.month}</div>}
              </div>}
            </div>

            {(termType!="") && <div>
              <p>Select a file to upload/update</p>
            </div>}

            <ToastContainer />

          {termType != "" && <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                background: "#e9e9e9",
                padding: "10px 12px",
                borderRadius: "6px",
                minWidth: "380px"
              }}
            >
                  <span style={{ fontWeight: "500" }}>Report File</span>

                  <input type="file" ref={fileInputRef1} onChange={handleFileChange} />
                  {file && isAnalyzing && (
                          <div className="d-flex align-items-center mb-2">
                            <div className="spinner-border text-primary me-2" role="status">
                              <span className="visually-hidden">Analyzing file...</span>
                            </div>
                            <span>Analyzing file, please wait...</span>
                          </div>
                        )}

                  {reportUploaded && fileLinks.Report?.url && (
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => window.open(fileLinks.Report.url, "_blank")}
                      >
                        View
                      </Button>
                  )}
                  <Button
                  type="button"
                    size="sm"
                    disabled={
                      !file ||
                      uploadingFileType === "Report" ||
                      isAnalyzing ||
                      deadlinePassed ||
                      (file && reportStatus === "error")
                    }
                    onClick={() =>
                      uploadSingleFile({
                        fileCategory: file,
                        fileType: "Report",
                        thesisStatusId,
                        studentId,
                        announcementId,
                        termType,
                        fileRef: fileInputRef1,
                        clearState: setFile
                      })
                    }
                >
                  {uploadingFileType === "Report" ? "Uploading..." : "Upload"}
                </Button>

                  {/* {reportResult && (
                <div style={{ fontWeight: "bold", alignSelf: "center" }}>
                  {reportResult.margin_issues?.length > 0 && (
                    <div>
                      {reportResult.margin_issues.map((issue, index) => (
                        <div key={index}>
                          Page {issue[0]} – {issue[1]}
                        </div>
                      ))}
                    </div>
                  )}
                  <div>{reportResult.message}</div>
                </div>
              )} */}

              {!file && (reportUploaded && uploadingFileType !== "Report" ? (
                    <span style={{ color: "green", fontWeight: 600 }}>
                      ✔ Uploaded
                    </span>
                  ):
                  (
                    <span style={{ color: "red", fontWeight: 600 }}>
                      ? Yet to upload
                    </span>
                  )
                )
                }
              

              </div>
          </div>}


              {(termType == 'EndTerm' || termType == 'EndTerm_Resubmission') && reportType !== 'CapstoneMethodology' && <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    background: "#e9e9e9",
                    padding: "10px 12px",
                    borderRadius: "6px",
                    minWidth: "380px"
                  }}
                >
                  <span style={{ fontWeight: "500" }}>Presentation File</span>
                <input type="file" ref={fileInputRef2} onChange={handlePresentationFileChange} />
                {errors.presentationFile && <div className="error-text">{errors.presentationFile}</div>}
                {presentationUploaded && fileLinks.Presentation_File?.url && (
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => window.open(fileLinks.Presentation_File.url, "_blank")}
                      >
                        View
                      </Button>
                  )}
                  <Button
                    type="button"
                    size="sm"
                    disabled={
                      !presentationFile ||
                      uploadingFileType === "Presentation_File" ||
                      deadlinePassed
                    }
                    onClick={() =>
                      uploadSingleFile({
                        fileCategory: presentationFile,
                        fileType: "Presentation_File",
                        thesisStatusId,
                        studentId,
                        announcementId,
                        termType,
                        fileRef: fileInputRef2,
                        clearState: setPresentationFile
                      })
                    }
                  >
                    {uploadingFileType === "Presentation_File" ? "Uploading..." : "Upload"}
                  </Button>

                  {!presentationFile && (presentationUploaded && uploadingFileType !== "Presentation_File" ? (
                    <span style={{ color: "green", fontWeight: 600 }}>
                      ✔ Uploaded
                    </span>
                  ):
                  (
                    <span style={{ color: "red", fontWeight: 600 }}>
                      ? Yet to upload
                    </span>
                  ))
                  }

              </div>}

              {reportType !== 'ProjectProposal' && reportType !== 'CapstoneMethodology' && (termType == 'EndTerm' || termType == 'EndTerm_Resubmission') && <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    background: "#e9e9e9",
                    padding: "10px 12px",
                    borderRadius: "6px",
                    minWidth: "380px"
                  }}
                >
                    <span style={{ fontWeight: "500" }}>RebuttalReport File</span>
                <input type="file" ref={fileInputRef3}
                onChange={handleRebuttalReportFileChange} />
                {errors.rebuttalReportFile && <div className="error-text">{errors.rebuttalReportFile}</div>}
                {rebuttalUploaded && fileLinks.Rebuttal_Report_File?.url && (
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => window.open(fileLinks.Rebuttal_Report_File.url, "_blank")}
                      >
                        View
                      </Button>
                  )}
                 <Button
                    type="button"
                    size="sm"
                    disabled={
                      !rebuttalReportFile ||
                      uploadingFileType === "Rebuttal_Report_File" ||
                      deadlinePassed 
                    }
                    onClick={() =>
                      uploadSingleFile({
                        fileCategory: rebuttalReportFile,
                        fileType: "Rebuttal_Report_File",
                        thesisStatusId,
                        studentId,
                        announcementId,
                        termType,
                        fileRef: fileInputRef3,
                        clearState: setRebuttalReportFile
                      })
                    }
                  >
                    {uploadingFileType === "Rebuttal_Report_File" ? "Uploading..." : "Upload"}
                  </Button>

                  {!rebuttalReportFile && (rebuttalUploaded && uploadingFileType !== "Rebuttal_Report_File" ? (
                    <span style={{ color: "green", fontWeight: 600 }}>
                      ✔ Uploaded
                    </span>
                  ):
                  (
                    <span style={{ color: "red", fontWeight: 600 }}>
                      ? Yet to upload
                    </span>
                  )
                )}

                </div>}

            {(termType == 'EndTerm' || termType == 'EndTerm_Resubmission') && reportType !== 'CapstoneMethodology' &&
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', width: '100%' }}>

              <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                background: "#e9e9e9",
                padding: "10px 12px",
                borderRadius: "6px",
                minWidth: "380px"
              }}
            >
                  <span style={{ fontWeight: "500" }}>Presentation Video</span>
                <input type="file" ref={fileInputRef4} onChange={handlePresentationVideoChange} />
                {errors.presentationVideo && <div className="error-text">{errors.presentationVideo}</div>}
                {presentationVideo && isAnalyzing && (
                          <div className="d-flex align-items-center mb-2">
                            <div className="spinner-border text-primary me-2" role="status">
                              <span className="visually-hidden">Analyzing file...</span>
                            </div>
                            <span>Analyzing file, please wait...</span>
                          </div>
                        )}
                        {presentationVideoUploaded && fileLinks.Presentation_Video?.url && (
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => window.open(fileLinks.Presentation_Video.url, "_blank")}
                      >
                        View
                      </Button>
                  )}
                  <Button
                    type="button"
                    size="sm"
                    disabled={
                      !presentationVideo ||
                      isAnalyzing ||
                      uploadingFileType === "Presentation_Video" ||
                      deadlinePassed ||
                      (presentationVideo && videoStatus === "error")
                    }
                    onClick={() =>
                      uploadSingleFile({
                        fileCategory: presentationVideo,
                        fileType: "Presentation_Video",
                        thesisStatusId,
                        studentId,
                        announcementId,
                        termType,
                        fileRef: fileInputRef4,
                        clearState:setPresentationVideo
                      })
                    }
                  >
                    {uploadingFileType === "Presentation_Video" ? "Uploading..." : "Upload"}
                  </Button>

                  {!presentationVideo && (presentationVideoUploaded && uploadingFileType !== "Presentation_Video" ? (
                    <span style={{ color: "green", fontWeight: 600 }}>
                      ✔ Uploaded
                    </span>
                  ):
                  (
                    <span style={{ color: "red", fontWeight: 600 }}>
                      ? Yet to upload
                    </span>
                  )
                )}

                {/* {videoMessage && (
                  <div style={{ marginTop: "5px", fontWeight: "bold" }}>
                    {videoMessage}
                  </div>
                )} */}

              </div>
            </div>}

              {(termType == 'EndTerm' || termType == 'EndTerm_Resubmission') && reportType !== 'CapstoneMethodology' && <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                background: "#e9e9e9",
                padding: "10px 12px",
                borderRadius: "6px",
                minWidth: "380px"
              }}
            >
                  <span style={{ fontWeight: "500" }}>Turnitin</span>
                <input type="file" ref={fileInputRef5} onChange={handleTurnitinChange} />
                {errors.turnitin && <div className="error-text">{errors.turnitin}</div>}
                {turnitin && isAnalyzing && (
                          <div className="d-flex align-items-center mb-2">
                            <div className="spinner-border text-primary me-2" role="status">
                              <span className="visually-hidden">Analyzing file...</span>
                            </div>
                            <span>Analyzing file, please wait...</span>
                          </div>
                        )}
                        {turnitinUploaded && fileLinks.Turnitin?.url && (
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => window.open(fileLinks.Turnitin.url, "_blank")}
                      >
                        View
                      </Button>
                  )}
                <Button
                    type="button"
                    size="sm"
                    disabled={
                      !turnitin ||
                      isAnalyzing ||
                      uploadingFileType === "Turnitin" ||
                      deadlinePassed ||
                      (turnitin && similarityStatus === "error" )
                    }
                    onClick={() =>
                      uploadSingleFile({
                        fileCategory: turnitin,
                        fileType: "Turnitin",
                        thesisStatusId,
                        studentId,
                        announcementId,
                        termType,
                        fileRef: fileInputRef5,
                        clearState: setTurnitin
                      })
                    }
                  >
                    {uploadingFileType === "Turnitin" ? "Uploading..." : "Upload"}
                  </Button>

                  {!turnitin && (turnitinUploaded && uploadingFileType !== "Turnitin" ? (
                    <span style={{ color: "green", fontWeight: 600 }}>
                      ✔ Uploaded
                    </span>
                  ):
                  (
                    <span style={{ color: "red", fontWeight: 600 }}>
                      ? Yet to upload
                    </span>
                  )
                )}
                  
                  {/* {similarityResult && (
                  <div>
                    <p><strong>Similarity Index:</strong> {similarityResult.similarity_index}%</p>
                    <p>{similarityResult.message}</p>
                  </div>
                )} */}

              </div>}

            {(termType == 'EndTerm' || termType == 'EndTerm_Resubmission') && reportType == 'Phase3' && <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', width: '100%' }}>

              <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                background: "#e9e9e9",
                padding: "10px 12px",
                borderRadius: "6px",
                minWidth: "380px"
              }}
            >
                  <span style={{ fontWeight: "500" }}>Code Demo File</span>
                <input type="file" ref={fileInputRef6} onChange={handleCodeDemoFileChange} />
                {errors.codeDemoFile && <div className="error-text">{errors.codeDemoFile}</div>}
                {codeDemoFile && isAnalyzing && (
                          <div className="d-flex align-items-center mb-2">
                            <div className="spinner-border text-primary me-2" role="status">
                              <span className="visually-hidden">Analyzing file...</span>
                            </div>
                            <span>Analyzing file, please wait...</span>
                          </div>
                        )}
                {codeDemoUploaded && fileLinks.Code_Demo_File?.url && (
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => window.open(fileLinks.Code_Demo_File.url, "_blank")}
                      >
                        View
                      </Button>
                  )}
                  <Button
                    type="button"
                    size="sm"
                    disabled={
                      !codeDemoFile ||
                      isAnalyzing ||
                      uploadingFileType === "Code_Demo_File" ||
                      deadlinePassed ||
                      (codeDemoFile && videoStatus === "error")
                    }
                    onClick={() =>
                      uploadSingleFile({
                        fileCategory: codeDemoFile,
                        fileType: "Code_Demo_File",
                        thesisStatusId,
                        studentId,
                        announcementId,
                        termType,
                        fileRef: fileInputRef6,
                        clearState: setCodeDemoFile
                      })
                    }
                  >
                    {uploadingFileType === "Code_Demo_File" ? "Uploading..." : "Upload"}
                  </Button>

                  {!codeDemoFile && (codeDemoUploaded && uploadingFileType !== "Code_Demo_File" ? (
                    <span style={{ color: "green", fontWeight: 600 }}>
                      ✔ Uploaded
                    </span>
                  ):
                  (
                    <span style={{ color: "red", fontWeight: 600 }}>
                      ? Yet to upload
                    </span>
                  )
                )}

              </div>
              </div>}
            
          </form>


        </div >}

        <DataGrid
          rows={submissions.filter(
            (row) =>
              row.report_type !== "ProjectParticular" &&
              !(degreeName === "PGD" && row.report_type === "ProjectProposal")
          )}
          getRowId={(row) => `${row.id}-${row.term_type}`}
          columns={finalColumns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          pageSizeOptions={[5, 10]}
          disableSelectionOnClick
        //checkboxSelection
        />
      </div >
      <div>
        {enrichedSlots
          .filter(slot =>
            isSlotActive(slot) &&
            slot.vivaIds?.some(id => myVivaIds.includes(id))
          )
          .map((slot, index) => (
            <VivaChatWidget
              key={slot.id}
              slot={slot}
              index={index}
              role="STUDENT"
            />
          ))}
        </div>
    </div>
  );
}
